export const verifyEmail = (email?: string) => {
  if (!email) {
    return false
  }
  return !!email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
}
